export const selectedVehicleStyle = {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    border: '1px solid #bbdefb',
    borderRadius: '4px',
    marginTop: '16px',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    '& .MuiAlert-icon': {
        color: '#1976d2',
        alignSelf: 'center'
    },
    '& .MuiAlert-message': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%'
    },
    '& .MuiAlert-action': {
        alignSelf: 'center'
    }
}

export const filterableService = {
    
}